import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { CLERK_LOCALES } from "../../lib/clerkLocales";

const appearance = {
  variables: {
    colorPrimary: "#00E599",
    colorPrimaryForeground: "#0B1017",
    colorBackground: "#121824",
    colorForeground: "#F3F4F6",
    colorMutedForeground: "#9CA3AF",
    colorNeutral: "#F3F4F6",
    colorInput: "#0B1017",
    colorInputForeground: "#F3F4F6",
    colorBorder: "#1F2A3E",
    fontFamily: "'IBM Plex Sans', sans-serif",
    borderRadius: "0.6rem",
  },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("c369-lang") || "en");
  useEffect(() => {
    const on = () => setLang(localStorage.getItem("c369-lang") || "en");
    window.addEventListener("c369-lang", on);
    return () => window.removeEventListener("c369-lang", on);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) { localStorage.setItem("c369-clerk-cfg", JSON.stringify(cfg)); return cancelled || setConfig(cfg); }
      } catch {
        const saved = JSON.parse(localStorage.getItem("c369-clerk-cfg") || "null");
        if (saved && !navigator.onLine) return cancelled || setConfig(saved);
      }
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={CLERK_LOCALES[lang]}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
